export const stt = (idx, current_page, page_size) => {
  if (current_page && current_page > 0) {
    return (current_page - 1) * page_size + 1 + idx
  }
  return idx + 1
}
